import { Input } from '../input';

interface DateTimePickerProps {
	value?: string | null;
	onChange?: (value: string | null) => void;
	placeholder?: string;
}

export const DateTimePicker = ({
	value,
	onChange,
	placeholder,
}: DateTimePickerProps) => {
	// Convert ISO string to datetime-local format (YYYY-MM-DDTHH:mm)
	let datetimeLocalValue = '';
	if (value && value.trim() !== '') {
		try {
			const date = new Date(value);
			if (!isNaN(date.getTime())) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				datetimeLocalValue = `${year}-${month}-${day}T${hours}:${minutes}`;
			}
		} catch (e) {
			// Invalid date, keep empty
			datetimeLocalValue = '';
		}
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newValue = e.target.value;

		if (!newValue) {
			onChange?.(null);
			return;
		}

		// Send datetime-local value as-is (backend interprets as EST)
		onChange?.(newValue.length === 16 ? `${newValue}:00` : newValue);
	};

	return (
		<Input
			type="datetime-local"
			value={datetimeLocalValue}
			onChange={handleChange}
			placeholder={placeholder}
			className="w-full"
		/>
	);
};
